import axios from 'axios'
import { ElNotification, ElMessageBox, ElMessage, ElLoading } from 'element-plus'
import { getToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams, blobValidate } from '@/utils/ruoyi'
import qs from 'qs'
import cache from '@/plugins/cache'
import { saveAs } from 'file-saver'
import useUserStore from '@/store/modules/user'
import { i18n } from '@/locales'

const { t } = i18n.global

let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: import.meta.env.VITE_APP_BASE_API,
  // 超时
  timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {

  // console.log(config)
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === true
  // 是否需要防止数据重复提交
  // const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  config.headers['APPID'] = import.meta.env.VITE_APP_APPID
  if (getToken() && !isToken) {
    config.headers['access-token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if (config.method === 'post') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.data = qs.stringify(config.data || {})

  }
  if (config.method === "postFormData" || config.method === "postformdata") {
    // console.log("postFormDatapostFormData")
    config.method = 'post'
    config.headers['Content-Type'] = 'multipart/form-data'
  }
  if (config.method === 'postjson' || config.method === 'postJson') {
    config.method = 'post'
    config.data = config.data || {}
  }

  // console.log('config', config)
  // if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
  //   const requestObj = {
  //     url: config.url,
  //     data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
  //     time: new Date().getTime()
  //   }
  //   const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
  //   const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
  //   if (requestSize >= limitSize) {
  //     console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
  //     return config;
  //   }
  //   const sessionObj = cache.session.getJSON('sessionObj')
  //   if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
  //     cache.session.setJSON('sessionObj', requestObj)
  //   } else {
  //     const s_url = sessionObj.url;                // 请求地址
  //     const s_data = sessionObj.data;              // 请求数据
  //     const s_time = sessionObj.time;              // 请求时间
  //     const interval = 1000;                       // 间隔时间(ms)，小于此时间视为重复提交
  //     if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
  //       const message = '数据正在处理，请勿重复提交';
  //       console.warn(`[${s_url}]: ` + message)
  //       return Promise.reject(new Error(message))
  //     } else {
  //       cache.session.setJSON('sessionObj', requestObj)
  //     }
  //   }
  // }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || res.data.message || errorCode['default']
  // 二进制数据则直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }
  if (code === 401) {
    if (!isRelogin.show) {
      isRelogin.show = true;
      ElMessageBox.confirm(t('request.loginExpired'), t('request.systemHint'), { confirmButtonText: t('request.logInAgain'), cancelButtonText: t('request.cancel'), type: 'warning' }).then(() => {
        isRelogin.show = false;
        useUserStore().logOut().then(() => {
          location.href = '/';
        })
      }).catch(() => {
        isRelogin.show = false;
      });
    }
    return Promise.reject(t('request.invalidSession'))
  } else if (code === 500) {
    ElMessage({ message: msg, type: 'error' })
    return Promise.reject(new Error(msg))
  } else if (code === 601) {
    ElMessage({ message: msg, type: 'warning' })
    return Promise.reject(new Error(msg))
  } else if (code !== 200) {
    ElNotification.error({ title: msg })
    return Promise.reject('error')
  } else {
    return Promise.resolve(res.data)
  }
},
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = t('request.networkError');
    } else if (message.includes("timeout")) {
      message = t('request.systemTimeout');
    } else if (message.includes("Request failed with status code")) {
      message = t('request.systemInterfaceError', message.substr(message.length - 3));
    }
    ElMessage({ message: message, type: 'error', duration: 5 * 1000 })
    return Promise.reject(error)
  }
)

// 通用下载方法
export function download(url, params, filename, config) {
  downloadLoadingInstance = ElLoading.service({ text: t('request.downloadingData'), background: "rgba(0, 0, 0, 0.7)", })
  return service.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
    const isBlob = blobValidate(data);
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      ElMessage.error(errMsg);
    }
    downloadLoadingInstance.close();
  }).catch((r) => {
    console.error(r)
    ElMessage.error(t('request.downloadingFileError'))
    downloadLoadingInstance.close();
  })
}
// 通过文件地址下载
export function downloadFileByUrl(url, name) {
  service({
    url: url.includes('http') ? url.replace(
      import.meta.env.VITE_APP_BASE_URL, '') : url,
    method: 'get',
    headers: {
      'token': 'Bearer ' + getToken()
    },
    responseType: "arraybuffer"
  }).then(res => {
    const blob = new Blob([res])
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容IE10
      navigator.msSaveBlob(blob, name)
    } else {
      //  chrome/firefox
      let aTag = document.createElement('a')
      aTag.download = name
      aTag.href = URL.createObjectURL(blob)
      aTag.click()
      URL.revokeObjectURL(aTag.href)
    }
  })
}
export default service
